var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.baseInfo.hasFinanceAccount || _vm.baseInfo.nextStage > 0)?_c('repayment-apply-activation'):_c('repayment-not-opened',{attrs:{"baseInfo":_vm.baseInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }